import { Icon } from 'src/components/ui-components/Icon';

export const IconRight = () => <Icon iconName="arrowRight" size="small" />;
